export const getCanVerifyOtp = ({ otpCode, otpCodeLength = 4 }: { otpCode: string; otpCodeLength?: number }) => otpCode.length === otpCodeLength;
